import React from "react";
import { IonAlert } from "@ionic/react";
import { Toast } from 'primereact/toast'

export function success(message: string, title: string = "Success") {
    ToastController.add({severity: "success", summary: title, detail: message});
}

export function error(message: string, title: string = "Fejl") {
    ToastController.add({severity: "error", summary: title, detail: message});
}

export function warn(message: string, title: string = "Advarsel") {
    ToastController.add({severity: "warn", summary: title, detail: message});
}

export function info(message: string, title: string = "Info") {
    ToastController.add({severity: "info", summary: title, detail: message});
}

export default class ToastController extends React.Component<any, any> {

    public static instance: ToastController; 

    public static add(options: any) {
        this.instance.pushDialog(options);
    }

    private static idCounter: number = 0;
    private toastRef: any;

    constructor(props: any) {
        super(props);
        this.state = {
            alerts: []
        }
        ToastController.instance = this;
        this.toastRef = React.createRef();
    }

    pushDialog = (options: any) => {
        this.toastRef.current?.show(options);
    }

    render() {
        return (
            <div style={{position: "relative", zIndex: 333333, left: "60px"}}>
              <Toast ref={this.toastRef} />
            </div>
        )
    }
}